// Tiny inline SVG sparkline — not Nivo. A ResponsiveLine per KPI card (4-5
// instances, each with its own ResizeObserver) is real overhead for a
// decorative 60x24px line; hand-rolling matches what the prototype itself does.
// Smooth quadratic-bezier path through the midpoints between consecutive
// points — a standard lightweight sparkline-smoothing technique (no curve
// library needed) — plus a thicker stroke.
function smoothPath(pts) {
    if (pts.length < 2) return '';
    let d = `M ${pts[0][0]},${pts[0][1]}`;
    for (let i = 1; i < pts.length; i++) {
        const [px, py] = pts[i - 1];
        const [x, y] = pts[i];
        const mx = (px + x) / 2, my = (py + y) / 2;
        d += ` Q ${px},${py} ${mx},${my}`;
    }
    const [lx, ly] = pts[pts.length - 1];
    d += ` L ${lx},${ly}`;
    return d;
}

function Sparkline({ data, color = '#6E58A6', width = 64, height = 24 }) {
    if (!data || data.length < 2) return null;
    const min = Math.min(...data), max = Math.max(...data);
    const range = max - min || 1;
    const pts = data.map((v, i) => [
        (i / (data.length - 1)) * width,
        height - ((v - min) / range) * (height - 4) - 2,
    ]);
    return (
        <svg width={width} height={height} style={{ display: 'block' }}>
            <path d={smoothPath(pts)} fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}

export default function KPICard({ label, value, fullValue, sub, badge, sparkline, onClick, active }) {
    return (
        <div
            className="kpi-card"
            onClick={onClick}
            style={onClick ? {
                cursor: 'pointer',
                borderLeft: active ? '4px solid #6E58A6' : '4px solid transparent',
                background: active ? '#F1EDF9' : undefined,
            } : undefined}
        >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div className="label">{label}</div>
                {badge && (
                    <span style={{
                        fontSize: 11, fontWeight: 700, padding: '2px 7px', borderRadius: 999,
                        color: badge.positive ? '#0F7B4F' : badge.positive === false ? '#B42318' : '#6E58A6',
                        background: badge.positive ? '#E4F7EC' : badge.positive === false ? '#FDECEC' : '#F1EDF9',
                    }}>
                        {badge.text}
                    </span>
                )}
            </div>
            <div className="value" title={fullValue || undefined}>{value}</div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', gap: 8 }}>
                {sub && <div className="sub">{sub}</div>}
                {sparkline && sparkline.length >= 2 && <Sparkline data={sparkline} />}
            </div>
        </div>
    );
}
